import { createClient } from '@sanity/client';

// Two separate Sanity projects:
// Production: 801yaoka (main branch)
// Development: pnkbjhym (dev branch)
const projectId = process.env.NEXT_PUBLIC_SANITY_PROJECT_ID || '801yaoka';
const dataset = process.env.NEXT_PUBLIC_SANITY_DATASET || 'production';
const apiVersion = process.env.NEXT_PUBLIC_SANITY_API_VERSION || '2024-01-01';

// Determine environment
const isDev = projectId === 'pnkbjhym';

// Client for reading data - no CDN for instant updates
export const studioClient = createClient({
  projectId,
  dataset,
  apiVersion,
  useCdn: false, // Disabled CDN for instant updates after changes
  perspective: 'published', // Only fetch published content
});

// Client for write operations (form submissions)
export const client = createClient({
  projectId,
  dataset,
  apiVersion,
  useCdn: false,
  token: process.env.NEXT_PUBLIC_SANITY_WRITE_TOKEN || undefined,
});
